import React, { useContext, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getPortfolioMetricsForinput } from 'gqlQueries/priceSimulator';
import { priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
const errorMessage: string = 'Something went wrong!';

function useFetchPortfolioMetricsForInput() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const [inputVariables, setInputVariables] = useState<any>(null);

    const { portfolioUpdateKpisData, setPortfolioUpdateKpisData, addNewPPGDetails } =
        useContext(priceSimulatorDataContext);

    const [fetchPortfolioMetricsForInput] = useLazyQuery(getPortfolioMetricsForinput, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
        fetchPolicy: 'network-only',
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPortfolioMetricsForInput } = payload;
            //if data present parse it
            if (getPortfolioMetricsForInput?.length > 0) {
                const payloadData: any = {};
                // prepare tooltip data
                getPortfolioMetricsForInput.forEach((item: any) => {
                    payloadData[item.kpiName] = item.kpiValue;
                });

                // duplicate existing data
                const newData = [...portfolioUpdateKpisData];

                const targetedData = newData[addNewPPGDetails.rowIndex];
                // update target data
                targetedData[addNewPPGDetails.columnName] = {
                    inActivationDate: [null],
                    inputList: inputVariables.map((i: any) => JSON.parse(i)),
                    isActive: true,
                    value: payloadData.value,
                    inActivationDateEpochTime: [null],
                };

                targetedData.kpiList[addNewPPGDetails.columnName] = payloadData;
                setPortfolioUpdateKpisData(newData);
                setData(true);
                return;
            }
            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
            setInputVariables(null);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchPortfolioMetricsForInput: (variables: any) => {
            setLoading(true);
            setError(null);
            setData(null);
            setInputVariables(variables?.variables?.inputList);
            fetchPortfolioMetricsForInput(variables);
        },
    };
}

export { useFetchPortfolioMetricsForInput };
